/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stripe_MonetizationInputs */

const en_stripe_monetization = /** @type {(inputs: Stripe_MonetizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Monetization`)
};

const es_stripe_monetization = /** @type {(inputs: Stripe_MonetizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monetización Stripe`)
};

const fr_stripe_monetization = /** @type {(inputs: Stripe_MonetizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monétisation Stripe`)
};

const de_stripe_monetization = /** @type {(inputs: Stripe_MonetizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe-Monetarisierung`)
};

const ja_stripe_monetization = /** @type {(inputs: Stripe_MonetizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripeによる収益化`)
};

const zh_stripe_monetization = /** @type {(inputs: Stripe_MonetizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe 变现设置`)
};

const ar_stripe_monetization = /** @type {(inputs: Stripe_MonetizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحقيق الدخل عبر Stripe`)
};

const id_stripe_monetization = /** @type {(inputs: Stripe_MonetizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monetisasi Stripe`)
};

const it_stripe_monetization = /** @type {(inputs: Stripe_MonetizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monetizzazione Stripe`)
};

const ru_stripe_monetization = /** @type {(inputs: Stripe_MonetizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Монетизация через Stripe`)
};

const pt_stripe_monetization = /** @type {(inputs: Stripe_MonetizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monetização Stripe`)
};

const ko_stripe_monetization = /** @type {(inputs: Stripe_MonetizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe 수익화`)
};

/**
* | output |
* | --- |
* | "Stripe Monetization" |
*
* @param {Stripe_MonetizationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const stripe_monetization = /** @type {((inputs?: Stripe_MonetizationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stripe_MonetizationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_stripe_monetization(inputs)
	if (locale === "es") return es_stripe_monetization(inputs)
	if (locale === "fr") return fr_stripe_monetization(inputs)
	if (locale === "de") return de_stripe_monetization(inputs)
	if (locale === "ja") return ja_stripe_monetization(inputs)
	if (locale === "zh") return zh_stripe_monetization(inputs)
	if (locale === "ar") return ar_stripe_monetization(inputs)
	if (locale === "id") return id_stripe_monetization(inputs)
	if (locale === "it") return it_stripe_monetization(inputs)
	if (locale === "ru") return ru_stripe_monetization(inputs)
	if (locale === "pt") return pt_stripe_monetization(inputs)
	return ko_stripe_monetization(inputs)
});